// OWNER: health module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  { path: 'health/diary', lazy: async () => ({ Component: (await pages()).DiaryPage }) },
  { path: 'health/diary/:entryId', lazy: async () => ({ Component: (await pages()).EntryDetailPage }) },
  { path: 'health/domains', lazy: async () => ({ Component: (await pages()).DomainsPage }) },
  { path: 'health/chc', lazy: async () => ({ Component: (await pages()).ChcPage }) },
  { path: 'health/attendance-allowance', lazy: async () => ({ Component: (await pages()).AttendanceAllowancePage }) },
];
